"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEntityViewLogRequestDTOSchema = exports.EntityLogDTO = exports.EntityLogDTOSchema = exports.EntityLogSchema = exports.EntityLogBaseSchema = exports.EntryLogSchema = exports.ENTITY_LOG_ACTIONS = exports.ENTITY_LOG_ENTITY_TYPES = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
var ENTITY_LOG_ENTITY_TYPES;
(function (ENTITY_LOG_ENTITY_TYPES) {
    ENTITY_LOG_ENTITY_TYPES["USER_PERSONAL_DOCUMENT"] = "UserPersonalDocument";
    ENTITY_LOG_ENTITY_TYPES["USER_TICKET"] = "UserTicket";
    ENTITY_LOG_ENTITY_TYPES["USER_REQUEST_SST"] = "UserRequestSST";
    ENTITY_LOG_ENTITY_TYPES["USER_SST"] = "UserSST";
    ENTITY_LOG_ENTITY_TYPES["USER_BUNDLE"] = "UserBundle";
    ENTITY_LOG_ENTITY_TYPES["USER_BUNDLE_TOKEN"] = "UserBundleToken";
})(ENTITY_LOG_ENTITY_TYPES || (exports.ENTITY_LOG_ENTITY_TYPES = ENTITY_LOG_ENTITY_TYPES = {}));
var ENTITY_LOG_ACTIONS;
(function (ENTITY_LOG_ACTIONS) {
    ENTITY_LOG_ACTIONS["CREATE"] = "create";
    ENTITY_LOG_ACTIONS["UPDATE"] = "update";
    ENTITY_LOG_ACTIONS["DELETE"] = "delete";
    ENTITY_LOG_ACTIONS["VIEW"] = "View";
    ENTITY_LOG_ACTIONS["DOWNLOAD"] = "Download";
})(ENTITY_LOG_ACTIONS || (exports.ENTITY_LOG_ACTIONS = ENTITY_LOG_ACTIONS = {}));
exports.EntryLogSchema = zod_1.z.object({
    field: zod_1.z.string().optional(),
    value: zod_1.z.string().optional(),
    action: zod_1.z.string(),
});
exports.EntityLogBaseSchema = zod_1.z.object({
    entry: zod_1.z.array(exports.EntryLogSchema),
    action: zod_1.z.nativeEnum(ENTITY_LOG_ACTIONS),
    entityId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    entityType: zod_1.z.nativeEnum(ENTITY_LOG_ENTITY_TYPES),
    userId: zod_1.z.instanceof(ObjectId_1.ObjectId),
});
exports.EntityLogSchema = exports.EntityLogBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.EntityLogDTOSchema = exports.EntityLogSchema.extend(__assign({ entityId: (0, ObjectId_1.ObjectIdString)('Invalid entityId'), userId: (0, ObjectId_1.ObjectIdString)('Invalid entityId') }, CommonMongoModelFields_1.CommonModelDTOFields));
exports.EntityLogDTO = {
    convertFromModel: function (model) {
        var _a;
        var dto = {
            _id: model._id.toString(),
            entry: model.entry,
            action: model.action,
            entityType: model.entityType,
            entityId: model.entityId._id ? model.entityId._id.toString() : model.entityId.toString(),
            entity: (0, ObjectId_1.isPopulated)(model.entityId) ? model.entityId : undefined,
            userId: ((_a = model.userId) === null || _a === void 0 ? void 0 : _a._id) ? model.userId._id.toString() : '',
            user: (0, ObjectId_1.isPopulated)(model.userId) ? User_1.UserDTO.convertFromModel(model.userId) : undefined,
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
        };
        return dto;
    },
};
exports.CreateEntityViewLogRequestDTOSchema = zod_1.z.object({
    entityType: zod_1.z.nativeEnum(ENTITY_LOG_ENTITY_TYPES),
    action: zod_1.z.nativeEnum(ENTITY_LOG_ACTIONS),
});
//# sourceMappingURL=EntityLog.js.map